"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openModal = exports.closeModal = exports.OPEN_MODAL = exports.MODAL_TYPES = exports.CLOSE_MODAL = void 0;
var CLOSE_MODAL = exports.CLOSE_MODAL = 'CLOSE_MODAL';
var OPEN_MODAL = exports.OPEN_MODAL = 'OPEN_MODAL';
var openModal = exports.openModal = function openModal(name, modalProps) {
  return {
    type: OPEN_MODAL,
    payload: {
      name: name,
      modalProps: modalProps
    }
  };
};
var closeModal = exports.closeModal = function closeModal(name) {
  return {
    type: CLOSE_MODAL,
    payload: {
      name: name
    }
  };
};
var MODAL_TYPES = exports.MODAL_TYPES = {
  NEW_API_KEY: 'NEW_API_KEY',
  REMOVE_API_KEY: 'REMOVE_API_KEY',
  EDIT_API_KEY_WHITELIST_IP_ADDRESS: 'EDIT_API_KEY_WHITELIST_IP_ADDRESS',
  CONFIRM_SINGLE_REPORT: 'CONFIRM_SINGLE_REPORT',
  CONFIRM_CYCLICAL_REPORT: 'CONFIRM_CYCLICAL_REPORT',
  CONFIRM_FIAT_DEPOSIT: 'CONFIRM_FIAT_DEPOSIT',
  CONFIRM_FIAT_WITHDRAW: 'CONFIRM_FIAT_WITHDRAW',
  CONFIRM_BLOCK_REPORT: 'CONFIRM_BLOCK_REPORT',
  CONFIRM_ORDER_REPORT: 'CONFIRM_ORDER_REPORT',
  ORDER_WARNING: 'ORDER_WARNING',
  RETAIL_SUBMIT_ORDER: 'RETAIL_SUBMIT_ORDER',
  EOTC_SUBMIT_ORDER: 'EOTC_SUBMIT_ORDER',
  NEW_AFFILIATE_KEY: 'NEW_AFFILIATE_KEY',
  ENABLE_2FA: 'ENABLE_2FA',
  DISABLE_2FA: 'DISABLE_2FA',
  DEPOSIT_STATUS: 'DEPOSIT_STATUS',
  DEPOSIT_REFERENCE_ID: 'DEPOSIT_REFERENCE_ID',
  SEND_REQUEST_2FA: 'SEND_REQUEST_2FA',
  SUBMIT_LIMIT_ORDER: 'SUBMIT_LIMIT_ORDER',
  MARGIN_DEPOSIT: 'MARGIN_DEPOSIT',
  MARGIN_WITHDRAW: 'MARGIN_WITHDRAW',
  MARGIN_TRADING: 'MARGIN_TRADING',
  MARGIN_CONFIRM: 'MARGIN_CONFIRM',
  MARGIN_DECLINE: 'MARGIN_DECLINE',
  MARGIN_DISABLE: 'MARGIN_DISABLE',
  MARGIN_CLOSE_POSITION: 'MARGIN_CLOSE_POSITION',
  MARGIN_REPAY_LOAN: 'MARGIN_REPAY_LOAN',
  MARGIN_TRANSFER_ASSETS: 'MARGIN_TRANSFER_ASSETS',
  GET_GOOGLE_2FA_RECOVERY_CODE: 'GET_GOOGLE_2FA_RECOVERY_CODE',
  REQUIRE_2FA: 'REQUIRE_2FA',
  PREVIEW_CLOSE_BY_SETTLEMENT: 'PREVIEW_CLOSE_BY_SETTLEMENT',
  INTEREST_ACCOUNTS_CONFIRMATION: 'INTEREST_ACCOUNTS_CONFIRMATION',
  INTEREST_LENDING_ENABLE: 'INTEREST_LENDING_ENABLE',
  INTEREST_DISABLE: 'INTEREST_DISABLE',
  UPDATE_LEVERAGE: 'UPDATE_LEVERAGE'
};